
  export const CARTS_RECEIVED = "CARTS_RECEIVED";
  export const SET_CART = "SET_CART";
  export const CREATE_CART = "CREATE_CART";
  export const SET_PROPERTY_CART = "SET_PROPERTY_CART";
  